import React from 'react';
import type { SvgIconProps } from '../../types/svg-icon-types';

const SvgIcon = ({ iconName, viewBox = '0 0 24 24', className = 'icon', additionalClasses = '' }: SvgIconProps) => {
  return (
    <svg className={`${className} ${additionalClasses}`} viewBox={viewBox} aria-hidden="true">
      <use xlinkHref={`/dist/assets/icons/sprite.svg#${iconName}`}></use>
    </svg>
  );
};

export default SvgIcon;
